import React from "react";

const RefreshLightIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1265 4.87348C12.2952 2.04217 7.70478 2.04217 4.87348 4.87348C2.04217 7.70478 2.04217 12.2952 4.87348 15.1265C7.70478 17.9578 12.2952 17.9578 15.1265 15.1265C15.7603 14.4927 16.2522 13.7708 16.6023 13.0001",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 17.25V13.75C17.25 13.1977 16.8023 12.75 16.25 12.75H12.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(RefreshLightIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;